import { render } from "./ReviewEdit.vue?vue&type=template&id=8c35ed88&ts=true"
import script from "./ReviewEdit.vue?vue&type=script&lang=ts"
export * from "./ReviewEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__